import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { ICompany } from '@leedpulse-monorepo/interfaces';

async function removeUserFromCompany(
  company: ICompany,
  auth: Authentication,
  userUid: string
): Promise<any> {
  try {
    return await HttpClient.post(
      '/company/remove-user',
      {
        user_uid: userUid,
        company_id: company.id,
      },
      auth.token,
      false,
      {
        // Used by company-level security middleware
        'x-api-key': company.api_key,
        'x-user-uid': auth.id,
      }
    );
  } catch (e) {
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new RemoveUserFromCompanyStatusFailure(
        'Le serveur ne répond pas'
      );
    }
    if (e instanceof Error) {
      throw new RemoveUserFromCompanyStatusFailure(e.message);
    }
    throw new RemoveUserFromCompanyStatusFailure('Unknown error');
  }
}

export class RemoveUserFromCompanyStatusFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default removeUserFromCompany;

